<script>
import { AASM_STATES } from './index'

export default {
  name: 'ShuttleTransferAasmState',
  props: {
    aasmState: {
      type: String,
      required: true,
    },
  },

  computed: {
    aasmStateLabel() {
      return AASM_STATES.find(as => as.value == this.aasmState)?.label
    },
  },
}
</script>

<template lang="pug">
span(:class="`st-state-${aasmState}`") {{ aasmStateLabel }}
</template>
